import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { isUspsGroupTheme, UspGroup } from '@grandvisionhq/content';
import { useFeatureToggles } from '@grandvisionhq/state';

var StepWrapper = (_param)=>{
    var { children , className , usps , onPrevSlide , onNextSlide  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "usps",
        "onPrevSlide",
        "onNextSlide"
    ]);
    const { featureConfigs: { configuratorUspsGroupTheme  } ,  } = useFeatureToggles();
    const theme = isUspsGroupTheme(configuratorUspsGroupTheme) ? configuratorUspsGroupTheme : 'light';
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, usps && /*#__PURE__*/ React__default.createElement(UspGroup, {
        items: usps,
        theme: theme,
        onPrevSlide: onPrevSlide,
        onNextSlide: onNextSlide
    }), /*#__PURE__*/ React__default.createElement("div", {
        "data-t": rest['data-t'],
        className: classnames('step-wrapper', className)
    }, children));
};

export { StepWrapper };
//# sourceMappingURL=StepWrapper.js.map
